import { useContext } from 'react'

import { PrebidModulesContext } from 'features/globalSetup/contexts/PrebidModulesContext'
import { GeneralCommonFormContainer } from 'features/globalSetup/forms/Prebid/Modules/GeneralCommonFormContainer'

export const GeneralTab = (): React.JSX.Element => {
  const { workspacePrebidModule } = useContext(PrebidModulesContext)

  if (!workspacePrebidModule) {
    throw Error('WorkspacePrebidModule should be accessible')
  }

  return <GeneralCommonFormContainer />
}
